// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f982ff6","732":"c8d09751","977":"4a818e4c"}[chunkId] + ".chunk.js";
};